import React, { useState } from "react";
import PropTypes from "prop-types";
import CountryFlag from "../CountryFlag";

const DestinationCard = ({ data }) => {
  const {
    name,
    city,
    state,
    country,
    bestSeason,
    popularAttractions,
    experiences,
    images,
  } = data;

  const [currentIndex, setCurrentIndex] = useState(0);

  const showNextImage = () => {
    setCurrentIndex((prevIndex) => (prevIndex + 1) % images.length);
  };

  const showPrevImage = () => {
    setCurrentIndex((prevIndex) =>
      prevIndex === 0 ? images.length - 1 : prevIndex - 1
    );
  };

  return (
    <div className="card">
      <div className="slider">
        {images.map((img, index) => (
          <img
            key={index}
            src={img}
            alt={`Slide ${index + 1}`}
            className={index === currentIndex ? "active" : ""}
          />
        ))}
        <button className="prev" onClick={showPrevImage}>
          &#10094;
        </button>
        <button className="next" onClick={showNextImage}>
          &#10095;
        </button>
      </div>

      <CountryFlag countryName={country} />

      <div className="content">
        <h2>{name}</h2>
        <p>
          <strong>City:</strong> {city}, {state}
        </p>
        <p>
          <strong>Country:</strong> {country}
        </p>
        <p>
          <strong>Best Season:</strong> {bestSeason}
        </p>
        <p>
          <strong>Popular Attractions:</strong> {popularAttractions.join(", ")}
        </p>
        <p>
          <strong>Experiences:</strong>
        </p>
        <div className="tags">
          {experiences.map((exp, index) => (
            <span key={index} className="tag">
              {exp}
            </span>
          ))}
        </div>

        <hr />

        <div className="link-container">
          <a
            href={`${window.location.origin}/destination/${data.id}`}
            target="_blank"
            rel="noopener noreferrer"
          >
            View more details and explore available packages.
          </a>
        </div>
      </div>
    </div>
  );
};

DestinationCard.propTypes = {
  data: PropTypes.shape({
    name: PropTypes.string.isRequired,
    city: PropTypes.string.isRequired,
    state: PropTypes.string.isRequired,
    country: PropTypes.string.isRequired,
    bestSeason: PropTypes.string.isRequired,
    popularAttractions: PropTypes.arrayOf(PropTypes.string).isRequired,
    experiences: PropTypes.arrayOf(PropTypes.string).isRequired,
    images: PropTypes.arrayOf(PropTypes.string).isRequired,
    id: PropTypes.string,
  }).isRequired,
};

export default DestinationCard;
